import { useLayoutEffect, useRef } from 'preact/hooks';
import { portraitCanvas } from '../../art/portrait.ts';

/** The player's halftone profile, the same one printed on their fiche and in the gazette. */
export function Portrait({ seed, width, class: className = '' }: { seed: number; width: number; class?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const height = Math.round(width * 1.25);

  useLayoutEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    const art = portraitCanvas(seed, Math.round(width * ratio), Math.round(height * ratio));
    canvas.width = art.width;
    canvas.height = art.height;
    canvas.getContext('2d')!.drawImage(art, 0, 0);
  }, [seed, width, height]);

  return <canvas ref={ref} class={`portrait ${className}`} style={{ width: `${width}px`, height: `${height}px` }} aria-hidden="true" />;
}
